// extracted by mini-css-extract-plugin
export default {"chatNotesContainer":"pzrr_D188yCSZ3kPvBGT"};